var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonEmptyString } from "graphql-scalars";
import { ArgsType, Field, InputType, ObjectType } from "type-graphql";
import { FilteredListQueryArgs } from "../filtering/FilteredListQueryArgs.js";
import { PointOpportunityNode } from "../resources/PointOpportunity.js";
import { TeamType } from "../resources/Team.js";
import { DateTimeScalar } from "../scalars/DateTimeISO.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { AbstractGraphQLPaginatedResponse } from "./PaginatedResponse.js";
let ListPointOpportunitiesResponse = class ListPointOpportunitiesResponse extends AbstractGraphQLPaginatedResponse {
    data;
};
__decorate([
    Field(() => [PointOpportunityNode]),
    __metadata("design:type", Array)
], ListPointOpportunitiesResponse.prototype, "data", void 0);
ListPointOpportunitiesResponse = __decorate([
    ObjectType("ListPointOpportunitiesResponse", {
        implements: (AbstractGraphQLPaginatedResponse),
    })
], ListPointOpportunitiesResponse);
export { ListPointOpportunitiesResponse };
let CreatePointOpportunityInput = class CreatePointOpportunityInput {
    name;
    opportunityDate;
    type;
    eventUuid;
    marathonUuid;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: false }),
    __metadata("design:type", String)
], CreatePointOpportunityInput.prototype, "name", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreatePointOpportunityInput.prototype, "opportunityDate", void 0);
__decorate([
    Field(() => TeamType, { nullable: false }),
    __metadata("design:type", String)
], CreatePointOpportunityInput.prototype, "type", void 0);
__decorate([
    Field(() => GlobalIdScalar, { nullable: true }),
    __metadata("design:type", Object)
], CreatePointOpportunityInput.prototype, "eventUuid", void 0);
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], CreatePointOpportunityInput.prototype, "marathonUuid", void 0);
CreatePointOpportunityInput = __decorate([
    InputType()
], CreatePointOpportunityInput);
export { CreatePointOpportunityInput };
let SetPointOpportunityInput = class SetPointOpportunityInput {
    name;
    opportunityDate;
    type;
    eventUuid;
};
__decorate([
    Field(() => GraphQLNonEmptyString, { nullable: true }),
    __metadata("design:type", Object)
], SetPointOpportunityInput.prototype, "name", void 0);
__decorate([
    Field(() => DateTimeScalar, { nullable: true }),
    __metadata("design:type", Object)
], SetPointOpportunityInput.prototype, "opportunityDate", void 0);
__decorate([
    Field(() => TeamType, { nullable: true }),
    __metadata("design:type", Object)
], SetPointOpportunityInput.prototype, "type", void 0);
__decorate([
    Field(() => GlobalIdScalar, { nullable: true }),
    __metadata("design:type", Object)
], SetPointOpportunityInput.prototype, "eventUuid", void 0);
SetPointOpportunityInput = __decorate([
    InputType()
], SetPointOpportunityInput);
export { SetPointOpportunityInput };
let ListPointOpportunitiesArgs = class ListPointOpportunitiesArgs extends FilteredListQueryArgs("PointOpportunityResolver", ["name", "opportunityDate", "type", "createdAt", "updatedAt", "marathonYear"]) {
};
ListPointOpportunitiesArgs = __decorate([
    ArgsType()
], ListPointOpportunitiesArgs);
export { ListPointOpportunitiesArgs };
//# sourceMappingURL=SinglePointOpportunityResponse.js.map